export default __webpack_public_path__ + "1f28452c7f2fd817a679378d7de6ccf8.ttf";